import {useSessionStore} from '@/stores'
import {useTranslation} from 'i18next-vue'
import {useDestroy} from './useDestroy'
import {useEventBus} from '@vueuse/core'
import {useMessageStore} from '@/stores/messagesStore'

export const useConnectionFailedCallback = () => {
  const {t} = useTranslation()
  const session = useSessionStore()
  const {silentlyDestroy} = useDestroy()

  useEventBus('strategy:failed').on(() => {
    const message = useMessageStore()
    message.addMessage({
      text: t('meeting.announcement.connectionFailed'),
      color: 'warning',
    })
    session.sessionFailed = true
    useEventBus('log:dumpTrigger').emit({reason: 'connection-failed'})
    setTimeout(() => {
      window.location.reload()
      silentlyDestroy()
    }, 5000)
  })
}
